// Tutorial.js
import React, { useState } from 'react';

import HeaderServices from '../Header/HeaderServices';
import FooterServices from '../Footer/FooterServices';
import './tutorial.css';

const Tutorial = () => {
  const [expandedCard, setExpandedCard] = useState(null);

  const tutorialCards = [
    {
      id: 1,
      title: "Insignias Volteon",
      icon: "",
      image: "images/R4/One.png",
      description: "Descubre los productos insignia",
      details: "Manuales completos.",
      buttonText: "Ver Productos",
      buttonLink: "/tutorial/productos",
      gradient: "tutorial-gradient-green",
      expandedText: "Accede a nuestra línea completa de productos electrónicos con manuales detallados y especificaciones técnicas. Cada producto incluye documentación profesional para facilitar su implementación."
    },
    {
      id: 2,
      title: "Tutoriales",
      icon: "",
      image: "/images/PCB/PCB1.png",
      description: "Aprende a usar tus componentes",
      details: "Ideas para tus proyectos",
      buttonText: "Ver Tutoriales",
      buttonLink: "/tutorial/tutoriales",
      gradient: "tutorial-gradient-blue",
      expandedText: "Explora nuestra biblioteca de tutoriales paso a paso. Desde proyectos básicos hasta implementaciones avanzadas, aprende a sacar el máximo provecho de tus componentes electrónicos."
    },
    {
      id: 3,
      title: "Talleres",
      icon: "",
      image: "/images/taller.jpeg",
      description: "Aprende las fechas de nuestros talleres presenciales y virtuales",
      details: "¡Adquiere habilidades!",
      buttonText: "Ver Talleres",
      buttonLink: "/tutorial/talleres",
      gradient: "tutorial-gradient-purple",
      expandedText: "Únete a nuestros talleres prácticos donde aprenderás directamente de expertos. Disponibles en formato presencial y virtual."
    }
  ];

  const handleCardClick = (cardId) => {
    setExpandedCard(expandedCard === cardId ? null : cardId);
  };

  return (
    <div className="tutorial-page-wrapper">
      <HeaderServices />

      {/* Hero Section con Introducción */}
      <section className="tutorial-hero-section">
        <div className="tutorial-hero-container">
          <h1 className="tutorial-hero-title">
            <span className="tutorial-hero-title-main">Centro de </span>
            <span className="tutorial-hero-title-accent">Recursos</span>
          </h1>
          <p className="tutorial-hero-description">
            Explora nuestra colección completa de productos electrónicos, aprende con nuestros 
            tutoriales especializados y únete a nuestros talleres presenciales y virtuales.
          </p>
          <p className="tutorial-hero-subtitle">
            Haz clic en cualquier tarjeta para descubrir más
          </p>
          
          {/* Decorative Elements */}
          <div className="tutorial-hero-decorative">
            <div className="tutorial-hero-dot tutorial-hero-dot-1"></div>
            <div className="tutorial-hero-dot tutorial-hero-dot-2"></div>
            <div className="tutorial-hero-dot tutorial-hero-dot-3"></div>
          </div>
        </div>
      </section>

      {/* Expandable Cards Section */}
      <section className="tutorial-cards-section">
        <div className="tutorial-cards-container">
          <div className="tutorial-cards-grid">
            {tutorialCards.map((card) => {
              const isExpanded = expandedCard === card.id;
              
              return (
                <div
                  key={card.id}
                  onClick={() => handleCardClick(card.id)}
                  className={`
                    tutorial-card 
                    ${isExpanded ? 'tutorial-card-expanded' : ''}
                    ${card.gradient}
                  `}
                >
                  {/* Background Image with Overlay */}
                  <div className="tutorial-card-bg">
                    <img
                      src={card.image}
                      alt={card.title}
                      className={`tutorial-card-image ${isExpanded ? 'tutorial-card-image-expanded' : ''}`}
                    />
                    <div className={`tutorial-card-overlay ${card.gradient}`}></div>
                  </div>

                  {/* Content */}
                  <div className="tutorial-card-content">
                    {/* Top Section */}
                    <div className="tutorial-card-top">
                      <div className={`tutorial-card-icon ${isExpanded ? 'tutorial-card-icon-expanded' : ''}`}>
                        {card.icon}
                      </div>
                      
                      <h2 className={`tutorial-card-title ${isExpanded ? 'tutorial-card-title-expanded' : ''}`}>
                        {card.title}
                      </h2>

                      <p className={`tutorial-card-description ${isExpanded ? 'tutorial-card-description-expanded' : ''}`}>
                        • {card.description}
                      </p>

                      <p className={`tutorial-card-details ${isExpanded ? 'tutorial-card-details-expanded' : ''}`}>
                        • {card.details}
                      </p>
                    </div>

                    {/* Bottom Section */}
                    <div className="tutorial-card-bottom">
                      {/* Expanded Content */}
                      <div className={`tutorial-card-expanded-content ${isExpanded ? 'tutorial-card-expanded-content-visible' : ''}`}>
                        <div className="tutorial-card-info-box">
                          <p className="tutorial-card-info-text">
                            {card.expandedText}
                          </p>
                        </div>
                      </div>

                      {/* Button */}
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          window.location.href = card.buttonLink;
                        }}
                        className="tutorial-card-button"
                      >
                        {card.buttonText}
                        <span className="tutorial-card-button-arrow">→</span>
                      </button>
                    </div>
                  </div>

                  {/* Expand Indicator */}
                  <div className={`tutorial-card-indicator ${isExpanded ? 'tutorial-card-indicator-expanded' : ''}`}>
                    <span className="tutorial-card-indicator-arrow">›</span>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Helper Text */}
          <div className="tutorial-helper-text">
            <p>
              {expandedCard 
                ? "Haz clic en otra tarjeta para explorar más opciones"
                : "Selecciona una tarjeta para ver información detallada"}
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="tutorial-cta-section">
        <div className="tutorial-cta-container">
          <div className="tutorial-cta-box">
            <h2 className="tutorial-cta-title">
              ¿Listo para comenzar tu viaje en electrónica?
            </h2>
            <p className="tutorial-cta-description">
              Únete a nuestra comunidad y accede a recursos exclusivos, soporte técnico y actualizaciones constantes
            </p>
            <button className="tutorial-cta-button">
              Explorar Todo el Contenido
            </button>
          </div>
        </div>
      </section>

      <FooterServices />
    </div>
  );
};

export default Tutorial;